<template>
  <div class="org-index-box">
    <!-- 组织列表页面 -->
    <org-index v-if="page === 1" />
    <!-- 项目列表页面 -->
    <!-- <project-list v-else-if="page === 2" /> -->
    <!-- 修改组织名称 -->
    <edit-org-name v-else-if="page===4" />
    <!-- 解散组织 -->
    <del-org-item v-else-if="page===7" />
    <!-- 转让组织第一步 -->
    <tranfer-org-first v-else-if="page===8" />
    <!-- 转让组织第二步 -->
    <tranfer-org-second v-else-if="page===9" />
    <org-index v-else />
  </div>
</template>

<script>
import OrgIndex from './OrgIndex'
import EditOrgName from './EditOrgName'
import DelOrgItem from './DelOrgItem'
import TranferOrgFirst from './TranferOrgFirst'
import TranferOrgSecond from './TranferOrgSecond'
export default {
  components: {
    OrgIndex,
    EditOrgName,
    DelOrgItem,
    TranferOrgFirst,
    TranferOrgSecond
  },
  data () {
    return {

    }
  },
  computed: {
    page () {
      return parseInt(this.$route.query.page)
    }
  }
}
</script>

<style>

</style>
<style lang="scss" scoped>
.org-index-box::v-deep {
  // padding: 12px;
  padding: 12px 0;
  .org-item {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 16px;
    margin:0 12px 12px;
    line-height: 24px;
    position: relative;
    display: flex;
    .iconicon-test25, .iconicon-test24 {
      font-size: 24px;
      color:#F6A953;
    }
    .iconicon-test7 {
      color: #42C27E;
      font-size: 24px;
    }
    .founder {
      color: #4CA0F2
    }
    .org-name {
      margin: 0 20px 0 10px;
      flex: 1;
      width: 290px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }
    .iconicon-test27 {
      position: absolute;
      right: 16px;
      font-size: 20px;
      color: #ccc;
      top: 16px;
    }
  }
   .cube-form-tip-box {
    font-size: 14px;
    line-height: 24px;
    padding: 12px 0;
    h3 {
      font-weight: 600;
    }
    p{
      color: #999;
    }
  }
  .create-box button.cube-btn-light {
     border-top: 1px solid #ebebeb;
    background: #fff;
  }
}
</style>
